// Btw-controle vóór verzending naar Gripp (incident 23 okt 2026: Alliander NV stond in
// Gripp op "BTW verlegd binnen EU 0%" en elke gegenereerde offerte kreeg stil 0% btw).
//
// De server weigert met 409 + code "btw_bevestigen" zodra een offerteregel iets anders
// dan 21% zou krijgen. Dan vragen we de PL: 21% gebruiken, of de 0% bewust aanhouden
// (buitenlandse klant, zusterbedrijf). Pas daarna gaat er iets naar Gripp.
import { authFetch } from '../../utils/authHelpers';
import { bevestig } from '../../utils/bevestig';

export const BTW_KEUZE_21 = '21';
export const BTW_KEUZE_BEHOUDEN = 'behouden';

export function isBtwBevestigen(status, d) {
  return status === 409 && d && d.code === 'btw_bevestigen';
}

// Vraagt de keuze. Geeft '21', 'behouden' of null (gestopt) terug.
export async function vraagBtwKeuze(btw = {}) {
  const tarief = (btw.tarieven || []).join(' / ') || '0% btw';
  const klant = btw.klant ? `${btw.klant} staat in Gripp op "${btw.klantTarief?.naam || tarief}". ` : '';
  const regels = btw.aantalRegels ? `${btw.aantalRegels} offerteregel(s)` : 'Offerteregels';
  const nl = btw.nederlandseKlant
    ? '\n\nDit is een Nederlandse klant: hier hoort vrijwel zeker 21% btw. Laat de btw van de relatie in Gripp corrigeren.'
    : '';
  const kies21 = await bevestig({
    titel: '⚠️ Deze offerte krijgt 0% btw',
    tekst: `${klant}${regels} zouden "${tarief}" krijgen in plaats van 21% btw.${nl}`,
    knop: 'Met 21% btw versturen',
    annuleer: 'Andere keuze…',
  });
  if (kies21) return BTW_KEUZE_21;
  const behouden = await bevestig({
    titel: '0% btw bewust aanhouden?',
    tekst: 'Alleen juist bij een klant in het buitenland (btw verlegd) of een zusterbedrijf (BTW Intern). '
      + `De offerte gaat dan met "${tarief}" naar Gripp.`,
    knop: 'Ja, 0% btw aanhouden',
    annuleer: 'Stoppen',
    gevaarlijk: true,
  });
  return behouden ? BTW_KEUZE_BEHOUDEN : null;
}

// POST naar create-gripp/update-offer; bij een btw-vraag eerst de keuze, dan opnieuw.
// Geeft { res, d } terug, of { geannuleerd: true } als de PL stopt.
export async function postMetBtwControle(url, body) {
  const post = (b) => authFetch(url, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b),
  });
  let res = await post(body);
  let d = await res.json().catch(() => ({}));
  if (isBtwBevestigen(res.status, d)) {
    const keuze = await vraagBtwKeuze(d.btw);
    if (!keuze) return { geannuleerd: true };
    res = await post({ ...body, btwKeuze: keuze });
    d = await res.json().catch(() => ({}));
  }
  return { res, d };
}
